import webApi, { baseURL } from "../../WebApi/WebApi";

//CO2 LIST

export const getAllCo2list = async (data) => {
  return await webApi.get(
    "/customer/co2-measurement/list-co2-measurement?searchKeyword="
  );
};
// https://nodeserver.mydevfactory.com:8000/api/customer/co2-measurement/list-co2-measurement?searchKeyword
